<template>
    <div style="display:none;"></div>
</template>

<script>
export default {
    name: 'JsonLd',

    props: {
        json: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            scriptEl: null
        }
    },

    mounted() {
        this.scriptEl = document.createElement('script')
        this.scriptEl.type = 'application/ld+json'
        this.scriptEl.text = JSON.stringify(this.json)
        document.head.appendChild(this.scriptEl)
    },

    unmounted() {
        if (this.scriptEl && document.head.contains(this.scriptEl)) {
            document.head.removeChild(this.scriptEl)
        }
    }
}
</script>
